
import React from 'react'
import { IconButton, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,  } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import CustomButton from "../../components/buttons/CustomButton";
import styles from "./popup.module.css";
import warning from "../../../assets/images/warning.svg";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        fontSize: "12px",
        fontWeight: 600,
        borderTop: "1px solid #EAECF0",
        // borderRight: "1px solid #EAECF0",
        borderBottom: "1px solid #EAECF0",
        borderLeft: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "12px",
        fontWeight: 400,
        padding: "5px",
        color: "#2B2B2B",
        borderTop: "1px solid #EAECF0",
        // borderRight: "1px solid #EAECF0",
        borderBottom: "1px solid #EAECF0",
        // borderLeft: "1px solid #EAECF0",
        textAlign: "center",
        whiteSpace: "nowrap",
    },
}));

const StyledTableRow = styled(TableRow)({
    backgroundColor: "#FFFFFF !important"
});

function AeranSubmitAlertPopup({ type, tableData, submitHandler, handleAlertPopup, label }) {
    return (
        <Modal open={Boolean(type)} onClose={handleAlertPopup}>
            <div className={styles.modalContainer}>
                <div className={styles.dialogBox} style={{ width: type === 'thursday' ? '40vw' : '20vw' }}>
                    <div className={styles.dialogBoxContent}>
                        <div className={`${styles.rejectContainer} ${styles.closeIconAlignmentDPS}`}>
                            <div></div>
                            <div className={styles.header} style={{ textAlign: 'center' }}>
                                {type === 'thursday' ?
                                     "Aera Plan changes" : <div className={styles.submitHeader}>
                                        <img src={warning} alt="warning icon" style={{ width: '24px', height: '24px'}} />
                                        Below site code - Line combinations are overloaded.
                                    </div>
                                }
                            </div>
                            <IconButton onClick={handleAlertPopup}>
                                <CloseIcon fontSize='large' className={styles.DPSCloseIcon}/>
                            </IconButton>
                        </div>
                    </div>
                    {typeof tableData === 'string' || tableData.length === 0 ? (
                        <Typography className={styles.subHeader} sx={{ textAlign: 'center', marginTop: '10px' }}>
                            {tableData}
                        </Typography>
                    ) : (
                        <TableContainer className={styles.table}>
                            <Table size="small" >
                                <TableHead sx={{ position: 'sticky', top: 0, zIndex: 999 }}>
                                    <TableRow sx={{ backgroundColor: "var(--primany-table-header-color)" }}>
                                        {Object.keys(tableData[0]).map((col, index) => (
                                            <StyledTableCell key={Math.random() * index}>
                                                <div>{col}</div>
                                            </StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.map((row, rowIndex) => (
                                        <StyledTableRow key={Math.random() * rowIndex}>
                                            {Object.keys(row).map((col, colIndex) => (
                                                <StyledTableCell key={Math.random() * colIndex} sx={{ border: "1px solid #EAECF0" }}>
                                                    <div>{row[col]}</div>
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                    {type === 'thursday' &&
                        <p className={styles.subHeader} style={{ textAlign: 'end', marginTop: '5px', fontSize: '10px', color: 'gray' }}>
                            <i>Note: Edit window is open for the Line-CBU level plan</i>
                        </p>
                    }
                    {type !== 'thursday' && (
                        <div className={styles.dialogBtn} sx={{ margin: "10px 0" }}>
                            <CustomButton label={label} type="popupCancel" onClick={() => submitHandler()} />
                            <CustomButton label="Modify Plan" type="reject" onClick={handleAlertPopup} />
                        </div>
                    )}
                </div>
            </div>
        </Modal>

    )
}

export default AeranSubmitAlertPopup;
